import { cva, type VariantProps } from "class-variance-authority";

import type { ProfileActivityFill } from "#/lib/calendarHeatmap";
import { cn } from "#/lib/utils";

const activityFillCellVariants = cva("overflow-hidden rounded-[2px] border border-border/60", {
  variants: {
    fill: {
      empty: "bg-muted",
      standard: "bg-primary",
      premium: "bg-premium",
      both: "bg-accent",
      unavailable: "border-dashed border-border/80 bg-muted/30",
    },
    size: {
      sm: "size-2.5 shrink-0",
      md: "size-3 shrink-0",
      lg: "size-3.5 shrink-0",
      full: "size-full min-h-2.5 min-w-2.5",
    },
  },
  defaultVariants: {
    fill: "empty",
    size: "sm",
  },
});

function ActivityFillCell({
  className,
  fill = "empty",
  size = "sm",
}: {
  className?: string;
  fill?: ProfileActivityFill;
  size?: VariantProps<typeof activityFillCellVariants>["size"];
}) {
  return <div className={cn(activityFillCellVariants({ fill, size }), className)} />;
}

export { ActivityFillCell, activityFillCellVariants };
